<template>
  <section id="update-shipment-batch" class="update-shipment-batch">
    <div class="container">
      <b-overlay :show="loading" rounded="sm" bg-color="#f8f9fa">
        <div class="card">
          <div class="card-body">
            <div class="card-text">
              <b-form @submit.stop.prevent="onUpdateStatus" class="update-shipment-batch-form">
                <b-row class="my-2">
                  <b-col sm="8">
                    <b-row>
                      <b-col sm="3" align-self="center">
                        <label>Shipment Status</label>
                      </b-col>
                      <b-col sm="5" align-self="center">
                        <label v-html="checkLatestStatus"></label>
                      </b-col>
                    </b-row>
                  </b-col >
                </b-row>
                <b-row class="my-2">
                  <b-col sm="8">
                    <b-row>
                      <b-col sm="3" align-self="center">
                        <label>Booking Code</label>
                      </b-col>
                      <b-col sm="5" align-self="start">
                        <b-form-input
                          id="booking-code"
                          v-model.trim="form.booking_code"
                          type="text"
                          aria-describedby="input-booking-code-feedback"
                          :placeholder="'Enter booking code'"
                          :class="{ 'is-invalid': $v.form.booking_code.$error }"
                        ></b-form-input>
                        <b-form-invalid-feedback
                          id="input-booking-code-feedback">
                          Booking Code should not empty
                        </b-form-invalid-feedback>
                      </b-col>
                      <b-col align-self="start">
                        <b-button
                          id="check-status-btn"
                          type="button"
                          @click="onCheckStatusBatch"
                          class="btn btn-lg btn-block check-status-btn">
                          CHECK STATUS
                        </b-button>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
                <b-row class="my-2">
                  <b-col sm="8">
                    <b-row>
                      <b-col sm="3" align-self="center">
                        <label>Action Status</label>
                      </b-col>
                      <b-col sm="5" align-self="start">
                        <b-form-select
                          v-model="form.shipment_status_batch"
                          placeholder="Please select status"
                          aria-describedby="input-shipment-status-feedback"
                          :options="availableStatusList"
                          :class="{ 'is-invalid': $v.form.shipment_status_batch.$error }">
                        <template #first>
                          <b-form-select-option :value="''" disabled>
                            Select shipment status
                          </b-form-select-option>
                        </template>
                        </b-form-select>
                        <b-form-invalid-feedback
                          id="input-shipment-status-feedback">
                          Shipment Status should selected
                        </b-form-invalid-feedback>
                      </b-col>
                      <b-col align-self="start">
                        <b-button
                          id="update-status-btn"
                          type="submit"
                          class="btn btn-lg btn-block update-status-btn">
                          CONFIRM
                        </b-button>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </b-form>
            </div>
          </div>
        </div>
      </b-overlay>
    </div>
  </section>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { shipmentBatchStatusList } from '../../utils/constant';

export default {
  name: 'Index',
  data() {
    return {
      loading: false,
      latest_status: '',
      form: {
        booking_code: '',
        shipment_status_batch: '',
      },
      shipment_status_list: [],
    };
  },
  computed: {
    checkLatestStatus() {
      return this.latest_status === '' ? 'Not Available' : this.latest_status;
    },
    availableStatusList() {
      if (this.shipment_status_list != null && typeof this.shipment_status_list !== 'undefined') {
        return this.shipment_status_list.map((status) => ({
          value: status.value,
          text: `[ ${status.value} ] ${status.text}`,
        }));
      }
      return [];
    },
  },
  validations: {
    form: {
      booking_code: { required },
      shipment_status_batch: { required },
    },
  },
  methods: {
    onUpdateStatus() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }
      this.$nextTick(() => {
        this.loading = true;
      });

      this.$store.dispatch('updateStatusShipmentBatch', this.form)
        .then((response) => {
          if (response.code === 200 || response.status_code === 200) {
            const responseLatestStatus = response.data != null ? response.data.latest_status : 'Not Available';
            const latest = shipmentBatchStatusList
              .find((status) => status.value === responseLatestStatus);
            this.latest_status = latest != null ? `[ ${latest.value} ] ${latest.text}` : 'Not Available';
            this.shipment_status_list = this.onReturnStatus(this.form.booking_code, latest);
            this.form.shipment_status_batch = '';
            this.$nextTick(() => { this.$v.form.$reset(); });
            this.loading = false;
          } else {
            this.latest_status = 'Not Available';
            this.shipment_status_list = [];
            this.form.shipment_status_batch = '';
            this.$nextTick(() => { this.$v.form.$reset(); });
            this.$swal({
              icon: 'error',
              title: 'Oops...',
              text: response.message || 'Something wrong',
            });
            this.loading = false;
          }
        })
        .catch((error) => {
          this.latest_status = 'Not Available';
          this.shipment_status_list = [];
          this.form.shipment_status_batch = '';
          this.$nextTick(() => { this.$v.form.$reset(); });
          let message = 'Something wrong';
          if (typeof error.response !== 'undefined') {
            message = `${error.response.data.message}`;
          }

          this.$swal({
            icon: 'error',
            title: 'Oops...',
            text: message,
          });
          this.loading = false;
        });

      if (this.loading) {
        setTimeout(() => {
          this.loading = false;
        },
        3000);
      }
    },
    onCheckStatusBatch() {
      this.$v.form.booking_code.$touch();
      if (this.$v.form.booking_code.$anyError) {
        return;
      }
      this.$nextTick(() => {
        this.loading = true;
      });

      this.$store.dispatch('shipmentBatchDetail', this.form.booking_code)
        .then((response) => {
          if (response.code === 200 || response.status_code === 200) {
            const responseLatestStatus = response.data != null ? response.data.latest_status : 'Not Available';
            const latest = shipmentBatchStatusList
              .find((status) => status.value === responseLatestStatus);
            this.latest_status = latest != null ? `[ ${latest.value} ] ${latest.text}` : 'Not Available';
            this.shipment_status_list = this.onReturnStatus(this.form.booking_code, latest);
            this.form.shipment_status_batch = '';
            this.$nextTick(() => { this.$v.form.$reset(); });
            this.loading = false;
          } else {
            this.latest_status = 'Not Available';
            this.shipment_status_list = [];
            this.form.shipment_status_batch = '';
            this.$nextTick(() => { this.$v.form.$reset(); });
            this.$swal({
              icon: 'error',
              title: 'Oops...',
              text: response.message || 'Something wrong',
            });
            this.loading = false;
          }
        })
        .catch((error) => {
          this.latest_status = 'Not Available';
          this.shipment_status_list = [];
          this.form.shipment_status_batch = '';
          this.$nextTick(() => { this.$v.form.$reset(); });
          let message = 'Something wrong';
          if (typeof error.response !== 'undefined') {
            message = `${error.response.data.message}`;
          }

          this.$swal({
            icon: 'error',
            title: 'Oops...',
            text: message,
          });
          this.loading = false;
        });

      if (this.loading) {
        setTimeout(() => {
          this.loading = false;
        },
        3000);
      }
    },
    onReturnStatus(bookingCode, latest) {
      const isReturn = bookingCode.substr(bookingCode.length - 2, bookingCode.length) === '-R';
      if (isReturn) {
        if (latest.value === 'COL') {
          // only PAPV (410)
          return shipmentBatchStatusList
            .filter((status) => latest != null && status.number === 410);
        }

        if (latest.value === 'COD') {
          // only PDO (2000)
          return shipmentBatchStatusList
            .filter((status) => latest != null && status.number === 2000);
        }
      }

      return shipmentBatchStatusList
        .filter((status) => latest != null && latest.next.includes(status.number));
    },
  },
};
</script>
<style>
.update-shipment-batch .spinner-border {
  color: #5e50a1;
}
.update-shipment-batch .update-shipment-batch-form label {
  font-family: "GothamMedium";
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #424143;
  margin-bottom: 0px;
}
.update-shipment-batch .update-shipment-batch-form input,
.update-shipment-batch .update-shipment-batch-form select,
.update-shipment-batch .update-shipment-batch-form input::placeholder {
  font-family: "GothamBook";
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #868686;
}
</style>
<style scoped>
.update-shipment-batch {
  padding-top: 20px;
}
.update-shipment-batch,
.update-shipment-batch .container,
.update-shipment-batch .container .row {
  height: 100%;
}
.update-shipment-batch .card {
  padding: 10px 40px
}
.update-shipment-batch .update-shipment-batch-form .check-status-btn,
.update-shipment-batch .update-shipment-batch-form .update-status-btn {
  font-family: "GothamMedium";
  font-size: 16px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
  background-color: #5e50a1;
  border: none;
}
.update-shipment-batch .update-shipment-batch-form input:focus,
.update-shipment-batch .update-shipment-batch-form select:focus,
.update-shipment-batch .update-shipment-batch-form .check-status-btn:focus,
.update-shipment-batch .update-shipment-batch-form .update-status-btn:focus {
  outline: none;
  box-shadow: none;
}
</style>
